import React, { useContext, useEffect, useState } from 'react'

import { useTenant } from '@rewardops/auth/src/client/use-tenant'
import { cn, LocalizedLink, Skeleton, useLocale } from '@rewardops/ui'

import { ResourcesContext } from '~/context/resources-provider'

interface MapleLogoProps {
  className?: string
}

const MapleLogo = ({ className }: MapleLogoProps) => {
  const tenant = useTenant()
  const { language } = useLocale()
  const resources = useContext(ResourcesContext)
  const resourceLogo = Boolean(resources?.logo?.url) ? resources?.logo : null
  const defaultLogo = { url: '/images/default-logo.png' }

  const [logo, setLogo] = useState(
    resourceLogo ??
      tenant?.logo?.[Boolean(language) ? language : 'en'] ??
      defaultLogo,
  )

  useEffect(() => {
    setLogo(resourceLogo ?? tenant?.logo?.[language] ?? defaultLogo)
  }, [language, resources?.logo?.url, tenant?.logo?.url])

  if (resources?.isLoading) {
    return <Skeleton className="h-10 w-32 bg-gray-300" />
  }

  return (
    logo && (
      <LocalizedLink
        href="/"
        id="maple-logo"
        className={cn('flex items-center space-x-1 text-white', className)}
      >
        <img
          className="cursor-pointer"
          src={logo.url}
          alt="Store Logo"
          width={120}
          height={120}
        />
      </LocalizedLink>
    )
  )
}

export default MapleLogo
